class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.events = [
      {
        el: this,
        type: "submit",
        callback: this.submitHandler.bind(this),
      },
    ];
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    handleEventListeners(this.events, "add");
  }

  disconnectedCallback() {
    handleEventListeners(this.events, "remove");
  }

  buildItem(formData) {
    const item = {};

    for (const [key, value] of formData.entries()) {
      if (key === "id") item.id = Number(value);
      if (key === "quantity") item.quantity = Number(value);

      if (key.includes("properties")) {
        const propertyKey = key.match(/\[(.*?)\]/)?.[1];
        if (!propertyKey) continue;
        item.properties ||= {};
        item.properties[propertyKey] = value;
      }
    }

    item.quantity = item.quantity !== 0 ? item.quantity : 1;
    return item;
  }

  async submitHandler(e) {
    e.preventDefault();
    if (!this.form?.reportValidity()) return;

    const submitButton = e.submitter;
    const item = this.buildItem(new FormData(this.form));
    const cartLineEditor = this.closest("cart-line-editor");

    if (cartLineEditor) {
      this.dispatchEvent(
        new CustomEvent("cart-line:save", {
          bubbles: true,
          detail: { item, submitButton },
        }),
      );
      return;
    }

    submitButton?.classList.add("btn--loading");

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: [item] }),
      });

      if (!response.ok) throw new Error("Something went wrong");
      window.location.href = "/cart";
    } catch (error) {
      console.error(error);
    } finally {
      submitButton?.classList.remove("btn--loading");
    }
  }
}

class ProductPropertyForm extends ProductForm {
  constructor() {
    super();
    this.events.push({
      el: this,
      type: "change",
      callback: this.changeHandler.bind(this),
    });
  }

  connectedCallback() {
    super.connectedCallback();
    this.syncMeatType();
  }

  changeHandler(e) {
    if (e.target.name === "properties[Meat choice]") this.syncMeatType();
  }

  syncMeatType() {
    const meatChoice = this.querySelector('[name="properties[Meat choice]"]:checked');
    const meatType = this.querySelector("[data-meat-type]");
    if (meatChoice && meatType) meatType.value = meatChoice.value;
  }
}

class StandardProductForm extends ProductPropertyForm {}
class MultiboxBundleProductForm extends ProductPropertyForm {}
class DigitalGiftCardProductForm extends ProductForm {}
class PhysicalGiftCardProductForm extends ProductForm {}

const productForms = {
  "standard-product-form": StandardProductForm,
  "multibox-bundle-product-form": MultiboxBundleProductForm,
  "digital-gift-card-product-form": DigitalGiftCardProductForm,
  "physical-gift-card-product-form": PhysicalGiftCardProductForm,
};

for (const [elementName, ProductFormClass] of Object.entries(productForms)) {
  if (!customElements.get(elementName)) customElements.define(elementName, ProductFormClass);
}
